import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { CHARACTERS } from "@/data/magicalContent";

export function CharacterSection() {
  return (
    <section id="characters" className="ns-section ns-characters" data-testid="characters-section">
      <motion.div className="ns-section-heading" initial={{ opacity: 0, y: 32 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
        <div><p className="ns-kicker">Chapter 01 · Your adventure crew</p><h2>Meet your<br /><em>adventure friends.</em></h2></div>
        <p className="ns-section-note">Every friend brings a little more magic to the journey.</p>
      </motion.div>
      <div className="ns-character-grid">
        {CHARACTERS.map((character, index) => (
          <motion.article className={`ns-character-card ns-character-${character.theme}`} key={character.name} data-testid={`character-card-${character.name.toLowerCase().replace(/[^a-z]+/g, "-")}`} initial={{ opacity: 0, y: 42 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index * 0.08 }} whileHover={{ y: -9 }}>
            <div className="ns-character-art"><span>{character.number}</span><img src={character.art} alt={`${character.name} official character artwork`} /></div>
            <div className="ns-character-info"><h3>{character.name}</h3><p>{character.role}</p><dl><div><dt>Special quality</dt><dd>{character.trait}</dd></div><div><dt>Favorite things</dt><dd>{character.loves}</dd></div></dl><span>Meet {character.name} <ArrowRight size={14} /></span></div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
